<div class="xvi-header-icon-renderer" [class.unsorted]="unsorted" [class.sortable]="isColumnSortable" (click)=progressSort()>
  <span>{{ params?.displayName }}</span>
  <img
    class="ml-5 crp"
    src="{{ 'assets/img/wrap.png' | xviSourcePath }}"
    (click)="onClick()"
    alt="Wrap"
    title="Wrap"
    style="width: 14px"
  />
  <div *ngIf="isColumnSortable" class="sort-icons-container" (click)=progressSort()>
    <xux-icon [class.visible]="descSort" class="dm-grid-sort-icon" icon="icon-arrow-up"></xux-icon>
    <xux-icon [class.visible]="ascSort" class="dm-grid-sort-icon dm-icon-arrow-down" icon="icon-arrow-down"></xux-icon>
  </div>
</div>
